import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { GenerateAIButton } from 'src/components'
import { useAccount } from 'src/hooks'
import { AIGenerateContentPrompt, IProductForm } from 'src/types'

interface IProps {
  isDisabled?: boolean
  locale?: string
  textPrompt?: string
  generationType?: AIGenerateContentPrompt
  iSIndentTop?: boolean
}

export const DescriptionGenerateButton = ({
  isDisabled,
  locale,
  textPrompt,
  generationType,
  iSIndentTop = false,
}: IProps) => {
  const [t] = useTranslation()
  const { values, setFieldValue } = useFormikContext<IProductForm>()
  const { data: account } = useAccount()

  const handleDescriptionGenerate = (value: string) => setFieldValue('description', value)

  return (
    <GenerateAIButton
      iSIndentTop={iSIndentTop}
      locale={locale}
      isDisabled={isDisabled}
      textPrompt={
        textPrompt
          ? textPrompt
          : `${t('products-form-ai-prompt.v')} ${values.name || '{product name}'} ${t(
              'products-form-ai-prompt-1.v',
            )} ${account?.account_holder || '{account name}'} ${t('products-form-ai-prompt-2.v')} ${
              account?.region || '{account region}'
            } ${account?.country || '{account country}'}`
      }
      generationType={generationType ? generationType : 'Product'}
      setGeneratedValue={handleDescriptionGenerate}
    />
  )
}
